import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampaignsService {
  private apiUrl = environment.apiURL + 'campaigns'; // URL del API
  private apiUrlLogs = environment.apiURL + 'campaign-logs'; // URL del API para logs
  constructor(private http: HttpClient) { }


  getCampaigns(
    pageNumber: number = 1,
    pageSize: number = 1000,
    params: any = {},
    sortColumn: string = 'name',
    sortDirection: string = 'asc'
  ): Observable<any> {

    return this.http.get(this.apiUrl, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }

 getCampaignsStage(
    pageNumber: number = 1,
    pageSize: number = 1000,
    params: any = {},
    sortColumn: string = 'name',
    sortDirection: string = 'asc',
    stage: string = ''
  ): Observable<any> {

    return this.http.get(this.apiUrl+'/stages/'+stage, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }

  addData(item: any): Observable<any> {
    return this.http.post(this.apiUrl + '/new', item);
  }
  // Método para añadir datos a la API
  updateCampaignData(reference: string, body: any): Observable<any> {
    return this.http.put(this.apiUrl + '/' + reference + '/update', body);
  }

  searchCampaign(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + '/' + reference);
  }
 searchCampaignStage(reference: string,stage: string): Observable<any> {
    return this.http.get(this.apiUrl + '/stages/' + stage + '/' + reference);
  }

  addOrderToCampaign(item: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/order/new`, item);
  }

  getTimeline(item: any): Observable<any> {
    return this.http.get(this.apiUrlLogs + '/timeline/' + item);
  }

  duplicateCampaign(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + '/' + reference + '/duplicate');
  }

  deleteCampaign(reference: string): Observable<any> {
    return this.http.delete(this.apiUrl + '/' + reference + '/delete');
  }

  getMatrix(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + '/' + reference + '/matrix');
  }

  getCampaignStocksGrouped2(): Observable<any> {
    return this.http.get(environment.apiURL + 'campaign-stocks/grouped');
  }
  getCampaignStocksGrouped(stage: string): Observable<any> {
    return this.http.get(environment.apiURL + 'campaign-stocks/campaign-grouped/' + stage);
  }
 getCampaignStocksStages(stage: string): Observable<any> {
    return this.http.get(environment.apiURL + 'campaign-stocks/campaign-stages/' + stage);
  }

  getCampaignsExpanded(
    pageNumber: number = 1,
    pageSize: number = 25,
    params: any = {},
    sortColumn: string = 'stage_updated_at',
    sortDirection: string = 'asc',
    stage: string = 'enabled'
  ): Observable<any> {
    return this.http.get(this.apiUrl + '/stages/' + stage + '/expanded', {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }
}
